import { render } from "./CarDataStatisticsDetail.vue?vue&type=template&id=4862245c&scoped=true&ts=true"
import script from "./CarDataStatisticsDetail.vue?vue&type=script&lang=ts"
export * from "./CarDataStatisticsDetail.vue?vue&type=script&lang=ts"

import "./CarDataStatisticsDetail.vue?vue&type=style&index=0&id=4862245c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4862245c"]])

export default __exports__